import { Container } from "@mantine/core";
import { useCreatePage } from "../../api/pages";
import { getCurrentWorkspace } from "../../services/userConfig";
import { useContext } from "react";
import { AuthContext } from "../../services/context";
import PageForm from "./PageForm";

const CreatePage = () => {
  const { mutate, isSuccess, isPending } = useCreatePage();
  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);

  const handleSubmit = (data, { onSuccess }) => {
    mutate(
      {
        ...data,
        eventId,
      },
      { onSuccess }
    );
  };

  return (
    <Container>
      <PageForm
        onSubmit={handleSubmit}
        isSubmitting={isPending}
        isSuccess={isSuccess}
        mode="create"
      />
    </Container>
  );
};

export default CreatePage;
